import { useNavigate } from 'react-router-dom'

import { Button } from '@Components/button/button'
import { Header } from '@Components/header/header'
import { ImageBackgroundSection } from '@Components/image-background-section/image-background-section'

import './status-screen.scss'
import { useHostConfig } from '../../hooks/use-host-config'
import { cloneElement } from 'react'
import { FormFloatingFooter } from '@Components/claim-flow/form-floating-footer'

const CLASS_NAME = 'status-screen'

export const UnknownWinScreen = () => {
  const hostConfig = useHostConfig()
  const navigate = useNavigate()
  return (
    <>
      <Header title="Schedule an Appointment" />
      <section>
        <ImageBackgroundSection backgroundUrl={''}>
          <img src={hostConfig.unknownWinFlow.backgroundImage} />
        </ImageBackgroundSection>
        <section className={`${CLASS_NAME}__general-body`}>
          {hostConfig.unknownWinFlow.details.map((element, index) =>
            cloneElement(element, { key: index }),
          )}
        </section>
      </section>
      <FormFloatingFooter>
        <section className={`floating-footer__buttons`}>
          <Button
            className={`floating-footer__next-button`}
            disabled={false}
            onClick={() => {
              navigate(`/create${location.search}`)
            }}>
            Complete
          </Button>
        </section>
      </FormFloatingFooter>
    </>
  )
}
